import React from 'react';
import styled from 'styled-components';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores';
import {LabelForm } from '../componentes_generales/componentes_formulario/labels';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import global_axios from '../../funciones_globales/interaccionapi';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { getItemDatosSesion } from '../../funciones_globales/manejosesion';
import {  cargarCatalogosGenericoAsync, cargarCatalogos_Otros} from '../../funciones_globales/catalogos';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
const PaginationLabels = styled.div`
    font-size: 12px;
`;

const PaginationButtons = styled.div`
    margin-bottom:10px;
`;

const ButtonUnion = styled.button`
    height: 25px;
    padding: 0px 10px;
    font-size: 11px;
    z-index: 0;
`;

class FormAdmin04 extends React.Component{   
  constructor(props) {
    super(props);
    this.state = {  
      planVigente:'',
      departamentos:[],
      usuario:'',
      cuentasContablesDepartamento:[],
      departamento_seleccionado:null,
      departamento_seleccionado_descripcion:'',
      cuenta_seleccionada:null,
      CuentasDepartamentoBase:[],
      columnDefs: [ 
                    {   header: "Cuenta Contable",
                        field: "Cuenta",
                        width: 300,
                        type: "string"
                    },
                    {   header: "Nombre",
                        field: "Descripcion",
                        width: 350,
                        type: "string"
                    }            
                  ],
          columnCuentasDepartamentoBase: [
                    {   header: "Cuenta Contable",
                        field: "Cuenta",
                        width: 300,
                        type: "string"
                    },
                    {   header: "Nombre",
                        field: "Descripcion",
                        width: 350,
                        type: "string"
                    },
                    {   header: "",
                        field: "eliminar",
                        width: 50,
                        type: "link_elim"
                    }      
                  ],          
        pagination: {
          totalFilas: 0,
          totalFilasPorPagina: 0,
          primaraFilaPagina: 0,
          ultimaFilaPagina: 0,
      }, 
      paginationHistorico: {
        totalFilas: 0,
        totalFilasPorPagina: 0,
        primaraFilaPagina: 0,
        ultimaFilaPagina: 0,
      },      
    };

    this.gridOptions = {
        enableColResize: true,
        enableSorting: true,
        enableFilter: true,
        rowSelection: "single",
        suppressScrollOnNewData: true,
        paginationAutoPageSize:true,
        pagination: true,
        suppressPaginationPanel: true,
      onRowDoubleClicked: event => {
      },
      onPaginationChanged: () => {
        if(!this.api){
            return;
        }
        let totalFilas = this.api.paginationGetRowCount();
        let totalFilasPorPagina = this.api.paginationGetPageSize();
        let ultimaFilaPagina = (totalFilasPorPagina * (this.api.paginationGetCurrentPage()+1));
        let indexPage = this.api.paginationGetCurrentPage();

        if( ultimaFilaPagina >  totalFilas){
            ultimaFilaPagina = totalFilas;
        }
   
        let pagination = {
            totalFilas: totalFilas,
            totalFilasPorPagina: totalFilasPorPagina,
            primaraFilaPagina: (totalFilasPorPagina * (indexPage + 1) - totalFilasPorPagina + 1),
            ultimaFilaPagina: ultimaFilaPagina
        };
       
        this.setState({pagination});
      },
    };
    this.gridOptionsCuentasDepartamentoBase = {
      enableColResize: true,
      enableSorting: true,
      enableFilter: true,
      rowSelection: "single",
      suppressScrollOnNewData: true,
      paginationAutoPageSize:true,
      pagination: true,
      suppressPaginationPanel: true,
      context: {
        componentParent: this
    }, 
    onRowDoubleClicked: event => {
    
    },
    onPaginationChanged: () => {
      if(!this.apiHistorico){
          return;
      }
      let totalFilas = this.apiHistorico.paginationGetRowCount();
      let totalFilasPorPagina = this.apiHistorico.paginationGetPageSize();
      let ultimaFilaPagina = (totalFilasPorPagina * (this.apiHistorico.paginationGetCurrentPage()+1));
      let indexPage = this.apiHistorico.paginationGetCurrentPage();

      if( ultimaFilaPagina >  totalFilas){
          ultimaFilaPagina = totalFilas;
      }
 
      let paginationHistorico= {
        totalFilas: totalFilas,
        totalFilasPorPagina: totalFilasPorPagina,
        primaraFilaPagina: (totalFilasPorPagina * (indexPage + 1) - totalFilasPorPagina + 1),
        ultimaFilaPagina: ultimaFilaPagina
    };
      this.setState({paginationHistorico});
    },
  };

    this.onGridReady = this.onGridReady.bind(this);   
    this.onGridReadyHistorico = this.onGridReadyHistorico.bind(this);   
    this.submit = this.submit.bind(this);
    this.limpiar = this.limpiar.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.getOptions_CtaContable = this.getOptions_CtaContable.bind(this);
    this.addCuenta = this.addCuenta.bind(this);
    this.immutablePush = this.immutablePush.bind(this);
    this.cargarCuentasDepartamento=this.cargarCuentasDepartamento.bind(this);
    this.eliminarCuentaDepartamento = this.eliminarCuentaDepartamento.bind(this);
  }  
  methodFromParent(id, datosFilaElim) {
    let eliminar = window.confirm(`¿Está seguro de eliminar la fila seleccionada?`);
    console.log(id)
    console.log(datosFilaElim)
    if (eliminar){
       this.eliminarCuentaDepartamento(id,datosFilaElim);
    }
  }
  eliminarCuentaDepartamento(id,datos){
    this.props.cambiar_VisualizacionLoading(true);
    let query = "?departamento="+this.state.departamento_seleccionado.value+"&plan="+ datos.PlanCuenta +"&cuenta=" + datos.Cuenta
    global_axios({
      method: 'GET',
      url: '/accesocuentadepartamento/eliminar_cuenta'+query
    }).then((response)=>{ 
        this.setState({
          CuentasDepartamentoBase:this.immutableDelete(this.state.CuentasDepartamentoBase,id)
        })
        this.props.cambiar_VisualizacionLoading(false)
        alert('La cuenta se elimino con exito')
    }).catch((err)=>{
      this.props.cambiar_VisualizacionLoading(false)
    })
  }
  addCuenta(){
    if(this.state.cuenta_seleccionada===null || this.state.cuenta_seleccionada===undefined || this.state.cuenta_seleccionada===''){
        alert('Por favor seleccione una cuenta contable');
    }else{
      let encontrado=false;
      for(let i=0; i<this.state.cuentasContablesDepartamento.length;i++){
        if(this.state.cuentasContablesDepartamento[i].Cuenta === this.state.cuenta_seleccionada.value){
          encontrado=true;
          break;
        }
      }
      if(encontrado){
        alert('La cuenta no se puede repetir.')
      }else{
        let plan = this.state.planVigente
        let cadena_busq = '?cadena_busq='+ this.state.cuenta_seleccionada.value +'&plan='+plan[0].value.toString()+'&departamento='+this.state.departamento_seleccionado.value;
        global_axios({
          method: 'GET',
          url: '/accesocuentadepartamento/cargar_cuenta'+cadena_busq
        }).then((response)=>{
            let cuentas=response.data;
            if(cuentas.length>0){
              for(let i=0; i< cuentas.length;i++){
                let cuentaContable={};
                cuentaContable.Cuenta=cuentas[i].Codigo;
                cuentaContable.Descripcion= cuentas[i].Descripcion;
                this.setState({ cuentasContablesDepartamento: this.immutablePush(this.state.cuentasContablesDepartamento, cuentaContable)});
              }
            }else{
              alert('La cuenta ya esta asociada al departamento')
            }
          
        })
      }
    }
  }
  cargarCuentasDepartamento(){
    this.props.cambiar_VisualizacionLoading(true);
      let plan = this.state.planVigente
      let cadena_busq = '?&plan='+plan[0].value.toString()+'&departamento='+this.state.departamento_seleccionado.value;
      this.setState({CuentasDepartamentoBase:[]})
      global_axios({
        method: 'GET',
        url: '/accesocuentadepartamento/cargar_cuentas_departamentos'+cadena_busq
      }).then((response)=>{
          let cuentas=response.data;
            for(let i=0; i< cuentas.length;i++){
              let cuentaContable={};
              cuentaContable.Cuenta=cuentas[i].Cuenta;
              cuentaContable.Descripcion= cuentas[i].det_cuenta.Descripcion;
              cuentaContable.PlanCuenta = cuentas[i].PlanCuenta;
              this.setState({ CuentasDepartamentoBase: this.immutablePush(this.state.CuentasDepartamentoBase, cuentaContable)});
            }
          this.props.cambiar_VisualizacionLoading(false);
      }).catch((error) => {
        this.props.cambiar_VisualizacionLoading(false);
        alert('No se pudieron cargar las cuentas del departamento');
      })
      
  }
  //CUENTAS
  getOptions_CtaContable(input, callback){
        var plan = "";
        if(this.state.planVigente!==null){
            if(this.state.planVigente.length > 0){
                plan = this.state.planVigente
                console.log("PLAN: ", plan)
                if (input.toString().length >= 2 ){
                    let cadena_busq = '?cadena_busq=' + input +'&plan='+plan[0].value.toString()+'&todasCuentas=S';
                    cargarCatalogosGenericoAsync('/cuentas', cadena_busq, callback)
                }
            }
        }
    }
 

  submit(e){
    e.preventDefault();
    if(this.state.cuentasContablesDepartamento.length>0){
      
          var sendData= {};
          sendData.PlanCuenta=this.state.planVigente[0].value;
          sendData.Departamento= this.state.departamento_seleccionado.value;
          sendData.cuentasContablesDepartamento= this.state.cuentasContablesDepartamento;
          sendData.Usuario= this.state.usuario;
          sendData.idRegAudit=this.props.idRegAudit;
          this.props.cambiar_VisualizacionLoading(true);
          global_axios(
            { method: 'POST',
              url: '/accesocuentadepartamento/',
              data: sendData
            }
          )
          .then(()=>{
           
            this.cargarCuentasDepartamento();
            this.setState({cuenta_seleccionada:null, cuentasContablesDepartamento:[]})
            this.props.cambiar_VisualizacionLoading(false);
            alert('Transacción procesada con exito')
          })
          .catch((err)=>{
            console.log(err)
              this.props.cambiar_VisualizacionLoading(false);
              alert('No se pudo procesar la transacción...');
          });
      }else{
        alert("Ingrese cuentas para proceder...")
      } 
     
  }
  onGridReady(params) {
    this.api = params.api;
    this.columnApi = params.columnApi;
  }
  onGridReadyHistorico(params) {
    this.apiHistorico = params.api;
    this.columnApiHistorico = params.columnApi;
  }
//   cargarDepartamentos(ruta){
//       global_axios.get(ruta)
//       .then((response)=>{
//        let departamentos=[];
//         for(let i=0; i < response.data.length; i++){
//             let departamento={};
//             departamento.value=response.data[i].value;
//             departamento.label= response.data[i].label+" ("+response.data[i].value+")"
//             departamentos.push(departamento)
//         }
//           this.setState({departamentos})
//       })
//       .catch((err)=>{
//           alert('No existe movimiento a presentar...');
//       });
//   }
  cargarDepartamentos(){
    return new Promise((resolve, reject) => {
      global_axios.get('/accesocuentadepartamento/departamentos/')
    .then((response)=>{
          resolve(response.data.map(item => ({value: item.Codigo.toString().toUpperCase(), label: `${item.Descripcion.toString().toUpperCase()} (${item.Codigo.toString().toUpperCase()})` })));
      })
      .catch((err)=>{
          reject('Error al cargar datos de cuentas departamento desde API: ' + err);
      });
  });
  }
  componentDidMount() {
    Promise.all([
        getItemDatosSesion('usuario'),
        this.cargarDepartamentos(),
        cargarCatalogos_Otros('GEN-PLANVIG'),
        this.props.generar_LogAuditoriaIngresoForm('1004'), 
    ])
    .then(([usuario,departamentos,planVigente]) => {
      this.setState(
        {
          usuario,departamentos,planVigente
        }) 
    })
    .catch(err => {
      console.log(err);
    });        
  }

  componentWillUnmount(){
    this.props.generar_LogAuditoriaSalidaForm('1004');
  } 
  limpiar(){
    this.setState({
      cuenta_seleccionada:null,
      departamento_seleccionado:null,
      departamento_seleccionado_descripcion:'',
      cuentasContablesDepartamento:[],
      CuentasDepartamentoBase:[]
      
    });
  }

  immutablePush(array, newItem){
    return [ ...array, newItem ];  
  }
  immutableDelete (arr, index) {
    var i = parseInt(index, 10);
    return arr.slice(0,i).concat(arr.slice(i+1));
  } 
  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }
  changeCuentaAdd(value){
    this.setState({cuenta_seleccionada: value})
  }

  render(){        
        return(
          <ContenedorForm porc_ancho={70}>
            <HeaderForm>
              <TituloForm>Registro de permisos Departamento – Cuentas contables</TituloForm>
            </HeaderForm>
            <CuerpoForm>
            <Row>
                <ContainerCol  className='col-sm-5' margen_arriba='10' margen_abajo='10'>
                    <LabelForm>Departamento:</LabelForm>
                    <ReactSelect  options={ this.state.departamentos }  value={this.state.departamento_seleccionado} func_onChange={(value)=>{this.setState({departamento_seleccionado: value,cuentasContablesDepartamento:[], departamento_seleccionado_descripcion: (value!==null)?value.label:''},()=>{(value!==null)?this.cargarCuentasDepartamento():this.limpiar()});}}/>
                </ContainerCol> 
                <ContainerCol className='col-sm-5' margen_arriba='10' margen_abajo='10'>
                    <LabelForm>Cuenta Contable:</LabelForm>
                    <ReactSelectAsync value={this.state.cuenta_seleccionada}  func_loadOptions={this.getOptions_CtaContable} func_onChange={(value)=>{this.changeCuentaAdd(value)}} /*func_onBlur={(value)=>{this.setCuenta(value)}}*//>
                </ContainerCol>
                <ContainerCol className='col-sm-2' margen_arriba='30' margen_abajo='10'>
                    <div className='input-group'>
                        <span className='input-group-btn'>
                            <ButtonUnion type='button' className='btn btn-success btn-sm' onClick={this.addCuenta}><i className='fa fa-plus'></i>Añadir</ButtonUnion>                
                        </span>
                    </div>
                </ContainerCol>
              </Row>
              <Row>
                <div className='col-md-12'>   
                      <AgGridRender altura='200px' data={this.state.cuentasContablesDepartamento} columnas={this.state.columnDefs}
                      gridOptions={this.gridOptions} onGridReady={this.onGridReady}/>
                  </div>
                  <div className="col-xs-12 col-sm-12">
                      <Row>
                          <ContainerCol className="col-xs-12 col-sm-12">
                              <PaginationLabels>
                                  {this.state.pagination.primaraFilaPagina} a {this.state.pagination.ultimaFilaPagina} de {this.state.pagination.totalFilas}
                              </PaginationLabels>
                              <PaginationButtons>
                                  <div className="btn-group btn-group-xs" role="group">
                                      <button style={{height:'30px'}} type="button" className="btn btn-default" onClick={() => this.api.paginationGoToFirstPage()}>
                                          <i className="fa fa-angle-double-left fa-fw"></i>Ir al inicio
                                      </button>
                                      <button style={{height:'30px'}} type="button" className="btn btn-default" onClick={() => this.api.paginationGoToPreviousPage()}>
                                          <i className="fa fa-angle-left fa-fw"></i>Anterior
                                      </button>
                                      <button style={{height:'30px'}} type="button" className="btn btn-default" onClick={() => this.api.paginationGoToNextPage()}>
                                          Siguiente<i className="fa fa-angle-right fa-fw"></i>
                                      </button>
                                      <button style={{height:'30px'}} type="button" className="btn btn-default" onClick={() => this.api.paginationGoToLastPage()}>
                                          Ir al final<i className="fa fa-angle-double-right fa-fw"></i>
                                      </button>
                                  </div>
                              </PaginationButtons>
                          </ContainerCol>
                      </Row>
                  </div>
              </Row>
              <Row>
                <ContainerCol className='col-xs-12 col-sm-12' align="center">
                  <h5><strong>Cuentas Contables Asociadas al Departamento:{this.state.departamento_seleccionado_descripcion}</strong></h5>
                </ContainerCol>
                <ContainerCol className='col-xs-12 col-sm-12'>
                   <AgGridRender altura='200px' data={this.state.CuentasDepartamentoBase} columnas={this.state.columnCuentasDepartamentoBase}
                    gridOptions={this.gridOptionsCuentasDepartamentoBase} onGridReady={this.onGridReadyHistorico}/>
                </ContainerCol>
                <div className="col-xs-12 col-sm-12">
                    <Row>
                        <ContainerCol className="col-xs-12 col-sm-12">
                            <PaginationLabels>
                                {this.state.paginationHistorico.primaraFilaPagina} a {this.state.paginationHistorico.ultimaFilaPagina} de {this.state.paginationHistorico.totalFilas}
                            </PaginationLabels>
                            <PaginationButtons>
                                <div className="btn-group btn-group-xs" role="group">
                                    <button style={{height:'30px'}} type="button" className="btn btn-default" onClick={() => this.apiHistorico.paginationGoToFirstPage()}>
                                        <i className="fa fa-angle-double-left fa-fw"></i>Ir al inicio
                                    </button>
                                    <button style={{height:'30px'}} type="button" className="btn btn-default" onClick={() => this.apiHistorico.paginationGoToPreviousPage()}>
                                        <i className="fa fa-angle-left fa-fw"></i>Anterior
                                    </button>
                                    <button style={{height:'30px'}} type="button" className="btn btn-default" onClick={() => this.apiHistorico.paginationGoToNextPage()}>
                                        Siguiente<i className="fa fa-angle-right fa-fw"></i>
                                    </button>
                                    <button style={{height:'30px'}} type="button" className="btn btn-default" onClick={() => this.apiHistorico.paginationGoToLastPage()}>
                                        Ir al final<i className="fa fa-angle-double-right fa-fw"></i>
                                    </button>
                                </div>
                            </PaginationButtons>
                        </ContainerCol>
                    </Row>
                </div>
              </Row>
              <Row margen_arriba={10}>  
                <form onSubmit={this.submit.bind(this)}> 
                    <div className='col-md-12'>
                      <div className='btn-group pull-right'>
                        <button type='submit' className='btn btn-primary btn-sm'><i className='fa fa-floppy-o fa-lg'></i> Guardar </button>
                        <button type='button' className='btn btn-default btn-sm' onClick={this.limpiar}><i className='fa fa-trash-o fa-lg'></i> Limpiar </button>
                      </div>
                    </div>                  
                </form>
              </Row>  
            </CuerpoForm>
          </ContenedorForm>
      );
  }
}

const mapStateToProps = ((state) => {
  return {  isVisibleLoading: state.ui.isVisibleLoading,
            Usuario: state.sesion.valoresSesionForm.Usuario,
            idRegAudit: state.sesion.valoresSesionForm.IdRegAudit
        }
});

const mapDispatchToProps = ((dispatch) => {  
  return bindActionCreators({ cambiar_VisualizacionLoading, generar_LogAuditoriaIngresoForm,
                              generar_LogAuditoriaSalidaForm }, dispatch)
});

export default connect (mapStateToProps, mapDispatchToProps)(FormAdmin04);